import { Box, Checkbox } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { ChipMenu } from '../../../../alerts/components/AlertsList/components/ChipMenu';
export const ListHeader = ({ dataTableProps }) => {
    var _a;
    const { t } = useAlertUiTranslation();
    let allAlertsChecked = false;
    let someAlertsChecked = false;
    const selectedAlertIds = (_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [];
    if (selectedAlertIds.length > 0) {
        allAlertsChecked = true;
        for (const row of dataTableProps.rows) {
            if (selectedAlertIds.includes(row.id)) {
                someAlertsChecked = true;
            }
            else {
                allAlertsChecked = false;
                if (someAlertsChecked) {
                    break;
                }
            }
        }
    }
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, p: 1, pr: 2 } },
        React.createElement(Checkbox, { checked: allAlertsChecked, indeterminate: !allAlertsChecked && someAlertsChecked, disabled: dataTableProps.rows.length === 0, onChange: (_event, checked) => {
                var _a;
                (_a = dataTableProps.onSelectAllRowsInCurrentPageClick) === null || _a === void 0 ? void 0 : _a.call(dataTableProps, dataTableProps.rows, checked);
            }, inputProps: {
                'aria-label': t('common.selectAllInCurrentPage'),
                'aria-checked': !allAlertsChecked && someAlertsChecked ? 'mixed' : undefined,
            } }),
        React.createElement(Box, { sx: { flexGrow: 1 } }),
        React.createElement(ChipMenu, { size: 'small', label: dataTableProps.sortColumnDesc ? t('common.newestFirst') : t('common.oldestFirst'), menuItems: [
                {
                    label: t('common.newestFirst'),
                    onClick: () => { var _a; return (_a = dataTableProps.onSortColumnChange) === null || _a === void 0 ? void 0 : _a.call(dataTableProps, 'orderBy', true); },
                },
                {
                    label: t('common.oldestFirst'),
                    onClick: () => { var _a; return (_a = dataTableProps.onSortColumnChange) === null || _a === void 0 ? void 0 : _a.call(dataTableProps, 'orderBy', false); },
                },
            ] })));
};
